export function formatRelativeTime(
  value: string | Date | null | undefined,
  fallback = 'recently',
): string {
  if (!value) {
    return fallback;
  }

  const timestamp = value instanceof Date ? value : new Date(value);
  const epochMs = timestamp.getTime();
  if (!Number.isFinite(epochMs)) {
    return fallback;
  }

  const diffSeconds = Math.max(0, Math.floor((Date.now() - epochMs) / 1000));

  if (diffSeconds < 60) {
    return `${diffSeconds}s ago`;
  }
  if (diffSeconds < 3600) {
    return `${Math.floor(diffSeconds / 60)}m ago`;
  }
  if (diffSeconds < 86400) {
    return `${Math.floor(diffSeconds / 3600)}h ago`;
  }
  return `${Math.floor(diffSeconds / 86400)}d ago`;
}
